import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

export interface UpdateIFRSQuestionExhibitDTO {
  title: string;
  type: "pdf" | "spreadsheet";
  filePath?: string; // Optional, used for PDF
  file?: File; // Optional, used for spreadsheet
}

export interface UpdateIFRSQuestionExhibitResponse {
  id: string;
  title: string;
  type: string;
  filePath: string;
}

type UpdateIFRSQuestionExhibitAPIResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: UpdateIFRSQuestionExhibitResponse;
};

export const UpdateIFRSQuestionExhibit = async (
  questionId: string,
  exhibitId: string,
  data: UpdateIFRSQuestionExhibitDTO
): Promise<UpdateIFRSQuestionExhibitAPIResponse> => {
  try {
    let response;

    if (data.type === "spreadsheet" && data.file) {
      // For Excel files, send as FormData with file
      const formData = new FormData();
      formData.append("file", data.file);
      formData.append("title", data.title);
      formData.append("type", data.type);

      response = await axios.patch(
        `/ifrs-question/${questionId}/exhibits/${exhibitId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    } else {
      // For PDF files, send as JSON with filePath
      response = await axios.patch(
        `/ifrs-question/${questionId}/exhibits/${exhibitId}`,
        {
          title: data.title,
          type: data.type,
          filePath: data.filePath,
        }
      );
    }

    return { data: response.data.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
